import { render, staticRenderFns } from "./AcompanhamentoVenda.vue?vue&type=template&id=058b51db&scoped=true"
import script from "./AcompanhamentoVenda.vue?vue&type=script&lang=js"
export * from "./AcompanhamentoVenda.vue?vue&type=script&lang=js"
import style0 from "./AcompanhamentoVenda.vue?vue&type=style&index=0&id=058b51db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058b51db",
  null
  
)

export default component.exports